import { render, staticRenderFns } from "./ReservationBook.vue?vue&type=template&id=787c1268"
import script from "./ReservationBook.vue?vue&type=script&lang=js"
export * from "./ReservationBook.vue?vue&type=script&lang=js"
import style0 from "./ReservationBook.vue?vue&type=style&index=0&id=787c1268&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports